import MonitoringCenterIcon from './component'

export default MonitoringCenterIcon